export default __webpack_public_path__ + "static/media/reports-file-alt-Connect-sm-gray.fee44431.svg";